import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useItemProvider } from 'modules/processes/components/ItemWizard/Providers/item'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

const FillInformationHeader = () => {
  const { itemType } = useItemProvider()
  const description =
    itemType === TaskConfigurationTypes.Single
      ? i18n.t('processes.process_settings.wizard.tasks.fill_information.custom')
      : i18n.t('processes.process_settings.wizard.tasks.fill_information.description')

  return (
    <Box gap="s8">
      <Text.Header2>
        {i18n.t('processes.process_settings.wizard.tasks.fill_information.title')}
      </Text.Header2>
      <Text.Normal>{description}</Text.Normal>
    </Box>
  )
}

export default FillInformationHeader
